<div class="d-sm-flex align-items-center justify-content-between mb-4">
  <h1 class="h3 mb-0 text-gray-800">Finanzas General</h1>
  <a href="#" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"><i
      class="fas fa-download fa-sm text-white-50"></i> Generate Report</a>
</div>

<!-- Content Row -->
<div class="row">

  <!-- Earnings (Monthly) Card Example -->
  <div class="col-xl-3 col-md-6 mb-4">
    <div class="card border-left-primary shadow h-100 py-2">
      <div class="card-body">
        <div class="row no-gutters align-items-center">
          <div class="col mr-2">
            <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
              Balance General</div>
            <div class="h5 mb-0 font-weight-bold" [ngStyle]="{'color': ( balance >0 ) ? 'blue':'red'  }"  >{{balance |currency:'ARS':'symbol':'1.0'}}</div>
          </div>
          <div class="col-auto">
            <i class="fas fa-calendar fa-2x text-gray-300"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Earnings (Monthly) Card Example -->
  <div class="col-xl-3 col-md-6 mb-4">
    <div class="card border-left-success shadow h-100 py-2">
      <div class="card-body">
        <div class="row no-gutters align-items-center">
          <div class="col mr-2">
            <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
              Ingresos</div>
            <div class="h5 mb-0 font-weight-bold text-gray-800">{{inputs |currency:'ARS':'symbol':'1.0'}}</div>
          </div>
          <div class="col-auto">
            <i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Pending Requests Card Example -->
  <div class="col-xl-3 col-md-6 mb-4">
    <div class="card border-left-warning shadow h-100 py-2">
      <div class="card-body">
        <div class="row no-gutters align-items-center">
          <div class="col mr-2">
            <div class="text-xs font-weight-bold text-warning text-uppercase mb-1">
              Deuda Pendiente</div>
            <div class="h5 mb-0 font-weight-bold text-gray-800">{{pendings |currency:'ARS':'symbol':'1.0'}}</div>
          </div>
          <div class="col-auto">
            <i class="fas fa-clipboard-list fa-2x text-gray-300"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Earnings (Monthly) Card Example -->
  <div class="col-xl-3 col-md-6 mb-4">
    <div class="card border-left-info shadow h-100 py-2">
      <div class="card-body">
        <div class="row no-gutters align-items-center">
          <div class="col mr-2">
            <div class="text-xs font-weight-bold text-info text-uppercase mb-1">Fichas Activas
            </div>
            <div class="row no-gutters align-items-center">
              <div class="col-auto">
                <div class="h5 mb-0 mr-3 font-weight-bold text-gray-800"></div>
              </div>
              <div class="col">
                <div class="progress progress-sm mr-2">
                  <div class="progress-bar bg-info" role="progressbar" style="width: 50%" aria-valuenow="50"
                    aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-auto">
            <i class="fas fa-user fa-2x text-gray-300"></i>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>

<div class="row">
  <div class="col-lg-6 mb-4">
    <!-- Approach -->
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Fichas Deudoras</h6>
      </div>
      <div class="card-body">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Ficha</th>
              <th scope="col">Telefono</th>
              <th scope="col">Monto</th>
              <th scope="col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of pending_users ;index as i">
              <th scope="row">{{i+1}}</th>
              <td>{{item.user?.fakeData?.username}}</td>
              <td>{{item.user?.fakeData?.whatsapp}}</td>
              <td>{{item.pending | currency:'ARS':'symbol':'1.0'}}</td>
              <td>
                <div class="btn-group">
                  <button type="button" class="btn btn-success dropdown-toggle btn-sm" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="true">
                    <i class="fas fa-dollar-sign"></i>
                  </button>
                  <div class="dropdown-menu">
                    <a class="dropdown-item" href="javascript:void(0);">Ver Finanzas</a>
                    <a class="dropdown-item" href="javascript:void(0);">Realizar Ingreso</a>                               
                  </div>
                </div>
              </td>
            </tr>        
          </tbody>
        </table>      
          
      </div>
    </div>

  </div>
  <div class="col-lg-6 mb-4">

    <!-- Illustrations -->
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Ultimos Ingresos</h6>
      </div>
      <div class="card-body">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Ficha</th>
              <th scope="col">Monto</th>
              <th scope="col">Fecha</th>
              <th scope="col">Admin</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of last_inputs ;index as i">
              <th scope="row">{{i+1}}</th>
              <td>{{item.user | ficha:'username' | async }}</td>
              <td>{{item.amount | currency:'ARS':'symbol':'1.0'}}</td>
              <td>{{item.date | date }}</td>
              <td>
                  {{item.admin | ficha : 'admin' | async }}
              </td>
            </tr>        
          </tbody>
        </table>     

      </div>
    </div>

    <!-- Approach -->
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Ultimas Publicaciones</h6>
      </div>
      <div class="card-body">
   
      </div>
    </div>

  </div>


</div>
